export const PARTICIPANT_TELEPHONE_NUMBERS_HELP_TEXT = {
    id: 'oe.connection.participantTelephoneNumbersHelpText',
    description: 'Input info text',
    defaultMessage: 'Enter each telephone number on a separate line.'
};

export const HOST_MEETING_TEXT = {
    id: 'oe.connection.hostMeeting',
    description: 'Button text',
    defaultMessage: 'Host Meeting',
};

export const TROUBLESHOOT_TEXT = {
    id: 'oe.connection.troubleshoot',
    description: 'Button text',
    defaultMessage: 'Troubleshoot',
};

export const JOIN_AS_ATTENDEE = {
    id: 'oe.connection.joinAsAttendee',
    description: 'Button text',
    defaultMessage: 'Join as Attendee',
};

export const PREVIEW_TEXT = {
    id: 'oe.connection.preview',
    description: 'Button text',
    defaultMessage: 'Preview',
};

export const NEW_UNIQUE_CONNECTION_TEXT = {
    id: 'oe.common.newUniqueConnection',
    description: 'Text label',
    defaultMessage: '+ New Unique Connection',
};

export const PANELIST_LINK_CONNECTION_TEXT = {
    id: 'oe.connection.panelistLink',
    description: 'Label text',
    defaultMessage: 'Panelist Link',
};

export const PANELIST_LABEL_TEXT = {
    id: 'oe.connection.label',
    defaultMessage: 'Label',
    description: 'Label text',
};

export const PANELIST_WEBINAR_ID = {
    id: 'oe.connection.webinarId',
    defaultMessage: 'Webinar ID',
    description: 'Label text',
};

export const CONNECTION_LINK_TEXT = {
    id: 'oe.connection.connectionLink',
    defaultMessage: 'Connection Link',
    description: 'Label text',
};

export const CONNECTION_PASSWORD_TEXT = {
    id: 'oe.connection.connectionPassword',
    defaultMessage: 'Connection Password',
    description: 'Label text',
};

export const PARTICIPANT_ID_TEXT = {
    id: 'oe.connection.participantId',
    defaultMessage: 'Participant ID',
    description: 'Label text'
};

export const ATTENDEE_ID_TEXT = {
    id: 'oe.connection.attendeeId',
    defaultMessage: 'Attendee ID',
    description: 'Label text',
};

export const CONNECTION_ACCOUNT_TEXT = {
    id: 'oe.connection.connectionAccount',
    defaultMessage: 'Connection Account',
    description: 'Label text',
};

export const UNIQUE_CONNECTION_DETAILS_UPDATED_TEXT = {
    id: 'oe.connection.uniqueConnectionDetailsUpdated',
    defaultMessage: 'Unique connection details updated',
    description: 'Notification text'
};

export const DELETE_THIS_CONNECTION_TEXT = {
    id: 'oe.connections.alerts.deleteThisConnection',
    defaultMessage: 'delete this connection',
    description: 'Confirmation text'
};

export const ATTENDEE_WILL_NO_HAVE_UNIQUE_CONNECTION_TEXT = {
    id: 'oe.connection.attendeeWillNoHaveUniqueConnection',
    defaultMessage: 'The attendee will no longer have a unique connection for this meeting.',
    description: 'Confirmation text'
};

export const ATTENDEE_EMAIL_TEXT = {
    id: 'oe.connection.attendeeEmail',
    defaultMessage: 'Attendee Email',
    description: 'Label text',
};

export const JOIN_MEETING = {
    id: 'oe.connection.joinMeeting',
    description: 'Button text',
    defaultMessage: 'Join Meeting',
};

export const MEETING_CONNECTIONS_AUTOREG_TEXT = {
    id: 'oe.connections.meeting.autoReg',
    defaultMessage: 'Auto Registration is {suffix}',
    description: 'Label text'
};

export const MEETING_CONNECTIONS_AUTO_SUBSCRIPTION_TEXT = {
    id: 'oe.connections.meeting.autoSubscription',
    defaultMessage: 'Auto Subscription is {suffix}',
    description: 'Label text'
};

export const PODIUM_LINK_ENABLED_TEXT = {
    id: 'oe.connections.podium.linkEnabled',
    defaultMessage: 'Podium Link is {suffix}',
    description: 'Label text'
};